import {DEPARTMENT_SET} from "../departmentActionList";
export const setDepartmentCollection=({collection=[]})=>{
 return async dispatch => {
     await dispatch({type: DEPARTMENT_SET.SET_DEPARTMENT_COLLECTION, payload: collection});
 }
}
